import { Table, Typography } from 'antd';
import { useMemo } from 'react';
import { block2config } from '../Block2';
import { DocumentPreviewBlockData } from './DocumentPreviewBlock1';
import { PreviewNestedData } from './PreviewNestedData';

export const DocumentPreviewBlock2 = ({ data }: DocumentPreviewBlockData) => {
  const tableData = useMemo(() => {
    const changedTableData = {
      key: 'block2Data',
      block2Data: {},
    };
    if (data) {
      changedTableData.block2Data = (
        <PreviewNestedData fieldsData={data} fieldsConfig={block2config} />
      );
    }
    return changedTableData;
  }, [data]);

  return (
    <div>
      <Typography.Title level={5}>Užduočių pritaikymas</Typography.Title>
      <Table
        pagination={false}
        columns={[
          {
            key: 'block2Data',
            title: 'Pritaikymo būdai',
            dataIndex: 'block2Data',
          },
        ]}
        dataSource={[tableData]}
        size="small"
      />
    </div>
  );
};
